import { Box } from '@material-ui/core';
import { ArticleTypeExternal, formatDateReadable, formatMoney } from '@nemuru-eng/js-api-client';

import { DialogHeader } from '@/components/shared/components/ItemDetail/components/shared/DialogHeader';
import { ItemDetailProps } from '@/components/shared/components/ItemDetail/types/ItemDetailProps';
import { StatusTag } from '@/components/shared/components/StatusTag/StatusTag';
import { Font } from '@/components/shared/components/Font';
import { ReadOnlyDataRow } from '@/components/shared/components/ReadOnlyDataRow';
import { Text } from '@/components/shared/components/Text';

export const Travel = ({ itemDetail, currency, itemStatus }: ItemDetailProps) => {
  if (itemDetail.article.type !== ArticleTypeExternal.TRAVEL) {
    return null;
  }

  return (
    <>
      <DialogHeader
        articleType={ArticleTypeExternal.TRAVEL}
        articleDetailId={itemDetail.id}
        total={{ value: itemDetail.totalPriceWithTax, currency }}
      />
      {itemStatus && (
        <Box pb={2}>
          <StatusTag type={itemStatus.statusColor} labelTextId={itemStatus.status} />
        </Box>
      )}
      <Box paddingY={2} display={'flex'} flexDirection={'column'}>
        <Font variant={'body1'} color={'title'}>
          <Text strong tId={'SUMMARY'} />
        </Font>
        <Box pt={2}>
          <ReadOnlyDataRow labelTextId={'TRAVEL'} value={itemDetail.article.name} underlined />
          {itemDetail.article.reference && (
            <ReadOnlyDataRow labelTextId={'REFERENCE'} value={itemDetail.article.reference} underlined />
          )}
          <ReadOnlyDataRow labelTextId={'UNITS'} value={`${itemDetail.units} x`} underlined />
          <ReadOnlyDataRow
            labelTextId={'UNIT_PRICE_WITH_TAX'}
            value={`${formatMoney({ value: itemDetail.article.unitPriceWithTax, currency })} `}
            underlined
          />
        </Box>
      </Box>
      <Box paddingY={2}>
        <Font variant={'body1'} color={'title'}>
          <Text strong tId={'DETAILS'} />
        </Font>
        <Box pt={2}>
          <ReadOnlyDataRow labelTextId={'DESCRIPTION'} value={itemDetail.article.description ?? '-'} underlined />
          <ReadOnlyDataRow labelTextId={'TRAVEL_CATEGORY'} value={itemDetail.article.travelCategory} underlined />
          <ReadOnlyDataRow labelTextId={'DESTINATION'} value={itemDetail.article.destination} underlined />
          <ReadOnlyDataRow
            labelTextId={'START_DATE'}
            value={formatDateReadable(itemDetail.article.startDate)}
            underlined
          />
          <ReadOnlyDataRow labelTextId={'END_DATE'} value={formatDateReadable(itemDetail.article.endDate)} underlined />
          <ReadOnlyDataRow labelTextId={'TRAVELLERS'} value={itemDetail.article.travellers ?? '-'} underlined />
        </Box>
      </Box>
    </>
  );
};
